import * as palette from "../palette";

import React from "react";

import Popover from "@govlaunch/popover";
import PropTypes from "prop-types";
import { SideContentCircle } from "../sidebar";
import StandardSidebarTray from "./StandardSidebarTray";
import { Toggle } from "react-powerplug";
import VerticalBlockCoordinates from "../VerticalBlockCoordinates";
import testId from "../testId";

export default function StandardSideToolbar({
  editorKey,
  editorState,
  focusEditor,
  onChange,
  offsetTop,
  offsetLeft,
  size,
}) {
  return (
    <VerticalBlockCoordinates editorKey={editorKey} editorState={editorState}>
      {({ top, visible }) => {
        if (visible) {
          return (
            <Toggle>
              {({ on, toggle }) => (
                <Popover
                  isOpen={on}
                  boxStyle={{
                    boxShadow: "0 10px 40px 0 rgba(34, 35, 40, 0.2)",
                    borderRadius: 4,
                  }}
                  onClickOutside={() => {
                    toggle();
                    setTimeout(focusEditor);
                  }}
                  render={() => (
                    <div>
                      <StandardSidebarTray
                        editorState={editorState}
                        onChange={(nextState) => {
                          toggle();
                          onChange(nextState);
                          setTimeout(focusEditor);
                        }}
                      />
                    </div>
                  )}
                >
                  {({ innerRef }) => {
                    return (
                      <SideContentCircle
                        {...testId("SideContentCircle/root")}
                        size={size}
                        color={palette.sealBlue}
                        hoverColor={palette.text}
                        top={top + offsetTop}
                        left={10 + offsetLeft}
                        visible={visible}
                        onClick={toggle}
                        onMouseDown={(event) => event.preventDefault()}
                        innerRef={innerRef}
                      />
                    );
                  }}
                </Popover>
              )}
            </Toggle>
          );
        }

        return null;
      }}
    </VerticalBlockCoordinates>
  );
}

StandardSideToolbar.propTypes = {
  editorKey: PropTypes.string.isRequired,
  editorState: PropTypes.object.isRequired,
  focus: PropTypes.bool.isRequired,
  focusEditor: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  size: PropTypes.number,
  offsetTop: PropTypes.number,
  offsetLeft: PropTypes.number,
};

StandardSideToolbar.defaultProps = {
  size: 20,
  offsetTop: 0,
  offsetLeft: 0,
};
